module.exports = __webpack_public_path__ + "static/media/2.16c98f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/bcbk8/2.png
// module id = 111
// module chunks = 0